export default "__VITE_ASSET__lOv5mFGL__"